/// @author Cyrill Tekord

import * as _ from "lodash";

declare type ConstructableFromProps<T> = { new(props: any): T };

declare global {
    interface Array<T> {
        removeItem(predicate: any);

        removeItemAt(index: number);

        clear();

        mapInto<T>(constructor: ConstructableFromProps<T>): T[];
    }

    interface Date {
        toYYMMDD(): string;
    }
}

Array.prototype.removeItem = function (predicate: any) {
    let index = _.findIndex(this, predicate);

    if (index != -1) {
        this.splice(index, 1);
    }

    return this;
};

Array.prototype.removeItemAt = function (index: number) {
    this.splice(index, 1);

    return this;
};

Array.prototype.clear = function () {
    this.splice(0);

    return this;
};

Array.prototype.mapInto = function <T>(constructor: ConstructableFromProps<T>): T[] {
    return this.map(
        (i) => new constructor(i),
    );
};

export function getEnumKeyByEnumValue<T extends { [index: string]: string }>(
    enumInstance: T,
    enumValue: string,
): keyof T | null {
    let keys = Object
        .keys(enumInstance)
        .filter(x => enumInstance[x] == enumValue);

    return keys.length > 0 ? keys[0] : null;
}

Date.prototype.toYYMMDD = function () {
    let yyyy = this.getFullYear();
    let mm = this.getMonth() < 9 ? "0" + (this.getMonth() + 1) : (this.getMonth() + 1); // getMonth() is zero-based
    let dd = this.getDate() < 10 ? "0" + this.getDate() : this.getDate();

    return `${yyyy}-${mm}-${dd}`;
};
